
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/software/eq-machine",
      function () {
        return require("private-next-pages/software/eq-machine/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/software/eq-machine"])
      });
    }
  